// extracted by mini-css-extract-plugin
export default {"slideContent":"tabs_slideContent__-XzhA","sliderContent":"tabs_sliderContent__48CB-","tabImage":"tabs_tabImage__OyspY"};